import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { secondsToSexagesimal } from '../../utils/time';
import { fetchVimeoOembedData } from '../../utils/vimeo';
import { getImageByWidth } from '../../utils/api';
import ProgressBar from './ProgressBar';


class ListItem extends Component {
  constructor (props) {
    super(props);
    this.state = {
      vimeoImage: null,
    };
  }

  componentDidMount () {
    const { previewImages, metadata } = this.props;
    if (
      (!previewImages || !previewImages.horizontalThumbnail.length) &&
      metadata &&
      (metadata.sourceUrl || metadata.sourceId)
    ) {
      this.fetchData();
    }
  }

  fetchData () {
    const { metadata } = this.props;
    const url = metadata.sourceUrl || `https://vimeo.com/${metadata.sourceId}`;
    fetchVimeoOembedData(url, 1280).then(data => {
      this.setState({ vimeoImage: data.thumbnailUrl });
    });
  }

  render () {
    const { baseUrl, name, slug, previewImages, duration, child, active, focused, onClick, progress } = this.props;
    const { vimeoImage } = this.state;
    const classes = classNames({
      'playlist-itemlist-item': true,
      background: active && !focused && !child,
      active,
      focused,
    });
    let thumbnailUrl = vimeoImage || '';
    if (previewImages && previewImages.horizontalThumbnail.length) {
      thumbnailUrl = getImageByWidth(previewImages.horizontalThumbnail, 300).url;
    }
    const durationFormatted = secondsToSexagesimal(duration);

    return (
      <div key={slug} className={classes}>
        <div className="thumbnail-container">
          {active
            ? (
              <div className="thumbnail active" style={{ backgroundImage: `url('${thumbnailUrl}')` }}>
                {progress ? <ProgressBar percent={progress} /> : null}
              </div>
            ) : (
              <Link to={`${baseUrl}/${slug}`} onClick={onClick}>
                <div className="thumbnail" style={{ backgroundImage: `url('${thumbnailUrl}')` }}>
                  {progress ? <ProgressBar percent={progress} /> : null}
                </div>
              </Link>
            )
          }
        </div>
        <div className="details">
          {active
            ? <h4 className="heading-display-light">{name}</h4>
            : <h4 className="heading-display-light"><Link to={`${baseUrl}/${slug}`} onClick={onClick}>{name}</Link></h4>
          }
          <div className="meta">{durationFormatted}</div>
        </div>
      </div>
    );
  }
}

ListItem.propTypes = {
  name: PropTypes.string,
  slug: PropTypes.string,
  shortDescription: PropTypes.string,
  longDescription: PropTypes.string,
  previewImages: PropTypes.object,
  duration: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  child: PropTypes.bool,
  active: PropTypes.bool,
  focused: PropTypes.bool,
  onClick: PropTypes.func,
};

ListItem.defaultProps = {
  child: false,
  active: false,
  focused: false,
  onClick: () => {},
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/Playlist/ListItem.js